import {Component, inject} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {StoreService} from "../../services/store.service";

@Component({
    selector: 'app-home-button',
    templateUrl: './home-button.component.html',
    standalone: false
})
export class HomeButtonComponent {

  private route = inject(ActivatedRoute);
  private router = inject(Router);
  protected store = inject(StoreService);

  redirectionLink?: string;

  constructor() {
    this.redirectionLink = this.store.getRedirectionLink();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed()
    ).subscribe(() => {
      const link = this.route.snapshot.queryParamMap.get('redirectionURL');
      if(link){
        this.redirectionLink = link;
        this.store.setRedirectionLink(link);
      }
    });
  }
}
